// extracted by mini-css-extract-plugin
module.exports = {"container":"Ads_container__1G0EX","analytics":"Ads_analytics__39M4Z"};